<mat-tab-group [selectedIndex]="selectedIndex" (selectedIndexChange)="tabChanged($event)">
  <!-- Quote Details Tab (includes Horse Details, Use of Horse, Cover Type, Cover Details) -->
  <mat-tab>
    <ng-template mat-tab-label>
      Quote Details
    </ng-template>
    <div class="card-body">
      <app-equine-quote-details
        [staticData]="staticData"
        [modelObject]="modelObject"
        [userDetailsLoaded]="userDetailsLoaded"
        (modelObjectUpdated)="modelObjectUpdated($event)"
        (GoToNextTab)="goToNextTab()"
      ></app-equine-quote-details>
    </div>
  </mat-tab>

  <!-- Additional Horse Details Tab -->
  <mat-tab [disabled]="unlockedTabIndex < 1">
    <ng-template mat-tab-label>
      Additional Horse Details
    </ng-template>
    <div class="card-body">
      <app-equine-additional-horse-details
        [staticData]="staticData"
        [modelObject]="modelObject"
        (modelObjectUpdated)="modelObjectUpdated($event)"
        (GoToNextTab)="goToNextTab()"
        (GoToPrevTab)="goToPrevTab()"
      ></app-equine-additional-horse-details>
    </div>
  </mat-tab>

  <!-- Claims Tab -->
  <mat-tab [disabled]="unlockedTabIndex < 2">
    <ng-template mat-tab-label>
      Claims
    </ng-template>
    <div class="card-body">
      <app-equine-claims
        [staticData]="staticData"
        [modelObject]="modelObject"
        (modelObjectUpdated)="modelObjectUpdated($event)"
        (GoToNextTab)="goToNextTab()"
        (GoToPrevTab)="goToPrevTab()"
      ></app-equine-claims>
    </div>
  </mat-tab>

  <!-- Statement of Facts Tab -->
  <mat-tab [disabled]="unlockedTabIndex < 3">
    <ng-template mat-tab-label>
      Statement of Facts
    </ng-template>
    <div class="card-body">
      <app-equine-statement-of-fact
        [staticData]="staticData"
        [modelObject]="modelObject"
        (modelObjectUpdated)="modelObjectUpdated($event)"
        (BackToClaimsTab)="tabChanged(2)"
        (GoToPremiumSummary)="goToPremiumSummary()"
      ></app-equine-statement-of-fact>
    </div>
  </mat-tab>

  <!-- Premium Summary Tab -->
  <mat-tab [disabled]="unlockedTabIndex < 4">
    <ng-template mat-tab-label>
      Premium Summary
    </ng-template>
    <div class="card-body">
      <app-equine-premium-summary
        [staticData]="staticData"
        [modelObject]="modelObject"
        (modelObjectUpdated)="modelObjectUpdated($event)"
        (BackToStatementOfFacts)="tabChanged(3)"
      ></app-equine-premium-summary>
    </div>
  </mat-tab>
</mat-tab-group>
